<!--*****************************************************************
  * Copyright (c) Certus Software, 2022.                            *
  *                                                                 *
  * This unpublished material is proprietary to Certus Software.    *
  * All rights reserved. The methods and techniques described       *
  * herein are considered confidential and/or trade secrets.        *
  * Reproduction or distribution, in whole or in part, is forbidden *
  * except by express written permission of Certus Software.        *
  *****************************************************************-->

<aside class="guide-aside">
  <nav [attr.aria-label]="(asideData.title | translate) + ', ' + ('guide.choiceAll.tableOfContents' | translate)">
    <a class="pushable green-push visible-hidden"  href="{{this.router.url.split('#')[0]}}#guideContent">
      <span class="front">
        <span>{{'app.skipToGuideContent' | translate}}</span>
      </span>
    </a>
    <p class="s-h4">
      {{asideData.title | translate}}
    </p>
    <ul>
      <li *ngFor="let asideItem of asideData.chapters; index as i">
        <a [routerLink]="asideItem.path" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}" [class]="asideItem.isMain?'main-ch':''" ariaCurrentWhenActive="page">
          <span *ngIf="asideItem.isMain" class="normal">{{i+1}}.</span>
          <span class="normal underline-animation ct-title">{{asideItem.title | translate}}</span>
        </a>
        <ul *ngIf="asideItem.subChapters.length !== 0">
          <li *ngFor="let asideChild of asideItem.subChapters">
            <a [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}" class="chld" [routerLink]="asideChild.path" ariaCurrentWhenActive="page">
              <span class="normal underline-animation ct-title">{{asideChild.title | translate}}</span>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
  <div class="divider"></div>
  <nav [attr.aria-label]="('guide.pcLaptop.windows.contentsPage.secondSectionTitle' | translate) + ', ' + ('guide.choiceAll.tableOfContents' | translate)">
    <p class="s-h4">
      {{'guide.pcLaptop.windows.contentsPage.secondSectionTitle' | translate}}
    </p>
    <ul>
      <li>
        <a  [routerLink]="'/guide/' + routePath + '/contact'" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
          <span class="normal underline-animation ct-title">{{'guide.pcLaptop.windows.contentsPage.chapters.8-0' | translate}}</span>
        </a>
      </li>
      <li>
        <a [routerLink]="'/guide/' + routePath + '/info'" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
          <span class="normal underline-animation ct-title">{{'guide.pcLaptop.windows.contentsPage.chapters.9-0' | translate}}</span>
        </a>
        <ul>
          <li>
            <a [routerLink]="'/guide/' + routePath + '/info/erasure-code-label'" class="chld" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
              <span class="normal"></span>
              <span class="normal underline-animation ct-title">{{'guide.pcLaptop.windows.contentsPage.chapters.9-1' | translate}}</span>
            </a>
          </li>
          <li>
            <a [routerLink]="'/guide/' + routePath + '/info/iso-image-file'" class="chld" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
              <span class="normal"></span>
              <span class="normal underline-animation ct-title">{{'guide.pcLaptop.windows.contentsPage.chapters.9-2' | translate}}</span>
            </a>
          </li>
          <li>
            <a [routerLink]="'/guide/' + routePath + '/info/boot-firmware-type'" class="chld" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
              <span class="normal"></span>
              <span class="normal underline-animation ct-title">{{'guide.pcLaptop.windows.contentsPage.chapters.9-3' | translate}}</span>
            </a>
          </li>
          <li>
            <a [routerLink]="'/guide/' + routePath + '/info/icmp-protocol'" class="chld" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
              <span class="normal"></span>
              <span class="normal underline-animation ct-title">{{'guide.pcLaptop.windows.contentsPage.chapters.9-4' | translate}}</span>
            </a>
          </li>
          <li>
            <a [routerLink]="'/guide/' + routePath + '/info/https-protocol'" class="chld" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
              <span class="normal"></span>
              <span class="normal underline-animation ct-title">{{'guide.pcLaptop.windows.contentsPage.chapters.9-5' | translate}}</span>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
  <div class="divider"></div>
  <p class="s-h4">
    {{'guide.pcLaptop.windows.contentsPage.chapters.10-0' | translate}}
  </p>
  <p class="normal">
    <a class="email misc" href="mailto:{{env.resources.websiteOrMail}}">{{env.resources.websiteOrMail}}</a>
  </p>
  <p class="normal">
    <a class="tel misc" href="tel:+3614680673">(06 1) 468-0673</a>
  </p>
</aside>
<div class="guide-contents-mobile">
  <ng-container *ngFor="let asideItem of asideData.chapters; index as i">
    <div *ngIf="asideItem.path === currentRoute">
      <button (click)="openGuideSheetMenu()">
        <span class="normal underline-animation ct-title">{{'guide.choiceAll.openGuideToc' | translate}}</span>
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    </div>
    <ng-container *ngFor="let asideChild of asideItem.subChapters;">
      <div *ngIf="asideChild.path === currentRoute">
        <button (click)="openGuideSheetMenu()">
          <span class="normal underline-animation ct-title">{{'guide.choiceAll.openGuideToc' | translate}}</span>
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
      </div>
    </ng-container>
  </ng-container>
  <div *ngIf="currentRoute === ('/guide/' + routePath + '/contact')">
    <button (click)="openGuideSheetMenu()">
      <span class="normal underline-animation ct-title">{{'guide.choiceAll.openGuideToc' | translate}}</span>
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
  </div>
  <div *ngIf="currentRoute === ('/guide/' + routePath + '/info')">
    <button (click)="openGuideSheetMenu()">
      <span class="normal underline-animation ct-title">{{'guide.choiceAll.openGuideToc' | translate}}</span>
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
  </div>
  <div *ngIf="currentRoute === ('/guide/' + routePath + '/info/erasure-code-label')">
    <button (click)="openGuideSheetMenu()">
      <span class="normal underline-animation ct-title">{{'guide.choiceAll.openGuideToc' | translate}}</span>
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
  </div>
  <div *ngIf="currentRoute === ('/guide/' + routePath + '/info/iso-image-file')">
    <button (click)="openGuideSheetMenu()">
      <span class="normal underline-animation ct-title">{{'guide.choiceAll.openGuideToc' | translate}}</span>
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
  </div>
  <div *ngIf="currentRoute === ('/guide/' + routePath + '/info/boot-firmware-type')">
    <button (click)="openGuideSheetMenu()">
      <span class="normal underline-animation ct-title">{{'guide.choiceAll.openGuideToc' | translate}}</span>
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
  </div>
  <div *ngIf="currentRoute === ('/guide/' + routePath + '/info/icmp-protocol')">
    <button (click)="openGuideSheetMenu()">
      <span class="normal underline-animation ct-title">{{'guide.choiceAll.openGuideToc' | translate}}</span>
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
  </div>
  <div *ngIf="currentRoute === ('/guide/' + routePath + '/info/https-protocol')">
    <button (click)="openGuideSheetMenu()">
      <span class="normal underline-animation ct-title">{{'guide.choiceAll.openGuideToc' | translate}}</span>
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
  </div>
  <ng-template let-bottomSheetRef="bottomSheetRef" #guideBottomSheet>
    <div>
      <div class="guideSheetHeader">
        <p class="s-h5">{{'guide.pcLaptop.windows.contentsPage.subjects' | translate}}</p>
        <button class="close-sidenav-btn" (click)="closeGuideSheetMenu()">
          <span class="gm"></span>
          <span class="visible-hidden">{{'guide.choiceAll.closeGuideToc' | translate}}</span>
        </button>
      </div>
      <div class="guide-contents-menu">
        <nav [attr.aria-label]="(asideData.title | translate) + ', ' + ('guide.choiceAll.tableOfContents' | translate)">
          <p class="s-h4">
            {{asideData.title | translate}}
          </p>
          <ul>
            <li *ngFor="let asideItem of asideData.chapters; index as i">
              <a [routerLink]="asideItem.path" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}" [class]="asideItem.isMain?'main-ch':''" (click)="closeGuideSheetMenu();" ariaCurrentWhenActive="page">
                <span *ngIf="asideItem.isMain" class="normal">{{i+1}}.</span>
                <span class="normal underline-animation ct-title">{{asideItem.title | translate}}</span>
              </a>
              <ul *ngIf="asideItem.subChapters.length !== 0">
                <li *ngFor="let asideChild of asideItem.subChapters">
                  <a class="chld" [routerLink]="asideChild.path" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}" (click)="closeGuideSheetMenu();" ariaCurrentWhenActive="page">
                    <span class="normal underline-animation ct-title">{{asideChild.title | translate}}</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
        <nav [attr.aria-label]="('guide.pcLaptop.windows.contentsPage.secondSectionTitle' | translate) + ', ' + ('guide.choiceAll.tableOfContents' | translate)">
          <p class="s-h4">
            {{'guide.pcLaptop.windows.contentsPage.secondSectionTitle' | translate}}
          </p>
          <ul>
            <li>
              <a [routerLink]="'/guide/' + routePath + '/contact'" (click)="closeGuideSheetMenu();" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
                <span class="normal underline-animation ct-title">{{'guide.pcLaptop.windows.contentsPage.chapters.8-0' | translate}}</span>
              </a>
            </li>
            <li>
              <a [routerLink]="'/guide/' + routePath + '/info'" (click)="closeGuideSheetMenu();" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
                <span class="normal underline-animation ct-title">{{'guide.pcLaptop.windows.contentsPage.chapters.9-0' | translate}}</span>
              </a>
              <ul>
                <li>
                  <a [routerLink]="'/guide/' + routePath + '/info/erasure-code-label'" class="chld" (click)="closeGuideSheetMenu();" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
                    <span class="normal"></span>
                    <span class="normal underline-animation ct-title">{{'guide.pcLaptop.windows.contentsPage.chapters.9-1' | translate}}</span>
                  </a>
                </li>
                <li>
                  <a [routerLink]="'/guide/' + routePath + '/info/iso-image-file'" class="chld" (click)="closeGuideSheetMenu();" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
                    <span class="normal"></span>
                    <span class="normal underline-animation ct-title">{{'guide.pcLaptop.windows.contentsPage.chapters.9-2' | translate}}</span>
                  </a>
                </li>
                <li>
                  <a [routerLink]="'/guide/' + routePath + '/info/boot-firmware-type'" class="chld" (click)="closeGuideSheetMenu();" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
                    <span class="normal"></span>
                    <span class="normal underline-animation ct-title">{{'guide.pcLaptop.windows.contentsPage.chapters.9-3' | translate}}</span>
                  </a>
                </li>
                <li>
                  <a [routerLink]="'/guide/' + routePath + '/info/icmp-protocol'" class="chld" (click)="closeGuideSheetMenu();" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
                    <span class="normal"></span>
                    <span class="normal underline-animation ct-title">{{'guide.pcLaptop.windows.contentsPage.chapters.9-4' | translate}}</span>
                  </a>
                </li>
                <li>
                  <a [routerLink]="'/guide/' + routePath + '/info/https-protocol'" class="chld" (click)="closeGuideSheetMenu();" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}" ariaCurrentWhenActive="page">
                    <span class="normal"></span>
                    <span class="normal underline-animation ct-title">{{'guide.pcLaptop.windows.contentsPage.chapters.9-5' | translate}}</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </ng-template>
</div>
